import React from "react";
import type { IIcon } from "./icons.types";

const Share: React.FC<IIcon> = ({
  width = 16,
  height = 16,
  color = "currentColor"
}) => (
  <svg
    width={width}
    height={height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.306 9.438c-.586 0-1.107.187-1.498.562L7.093 8.25v-.188-.187l3.715-1.75c.39.375.912.563 1.498.563 1.238 0 2.216-.938 2.216-2.125 0-1.188-.978-2.188-2.216-2.188-1.238 0-2.215.938-2.215 2.125v.188l-3.65 1.75c-.39-.313-.911-.563-1.433-.563-1.238 0-2.215.938-2.215 2.125 0 1.188.977 2.125 2.215 2.125.587 0 1.108-.188 1.5-.563l3.713 1.75v.188c0 1.188.978 2.125 2.216 2.125 1.238 0 2.215-.938 2.215-2.125a2.358 2.358 0 00-2.346-2.063z"
      fill={color}
    />
  </svg>
);

export { Share };
